import DpFormMixin from 'src/core/components/DpForm/DpFormMixin.js'
import DpForm from 'src/core/components/DpForm/DpForm2.vue'
import CategoriaModel from 'src/model/veiculo/CategoriaModel.js'
import CarroceriaModel from 'src/model/veiculo/CarroceriaModel.js'
import NotificacaoMixin from 'src/core/mixin/NotificacaoMixin'
import Upload from 'src/components/Upload.vue'

export default {
  name: 'CategoriaForm',
  components: { DpForm, Upload },
  mixins: [DpFormMixin, NotificacaoMixin],
  data () {
    return {
      categorias: [],
      modelPadrao: new CarroceriaModel(),
      modelCategoria: new CategoriaModel()
    }
  },
  mounted () {
    this.modelCategoria.getListagem().then((response) => {
      this.categorias = response.dados ?? []
    }).catch((error) => {
      this.notificacao('erro', error.msg)
    })
  },
  methods: {
    setarImagem (e) {
      this.modelPadrao.form.foto = e.arquivo
      this.modelPadrao.form.foto_url_completa = e.arquivo.arquivo_url_completa
    }
  }
}
